import React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { Divider } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { ColorBoxFilter } from '../components/color-box-filter/ColorBoxFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';
import st from '../shared.module.sass';

export const UpperCheckboxesPopover = ({ onCountChange, ...props }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const [sleeve, color] = useWatch({ name: ['sleeve_lengths', 'upper_clothing_colors'] });
  const filterCount = [sleeve, color]
    .filter((arr) => Array.isArray(arr) && arr.length > 0).length > 0
    ? 1 : 0;
  useFilterCount('upper', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="upperFilter"
      triggerValue={t('events:карточка.верх')}
      {...props}
    >
      <ColorBoxFilter
        control={control}
        isMulti
        label={t('events:upper_clothing_colors')}
        name="upper_clothing_colors"
        options={EVENT_ENUMS.UPPER_BODY.UPPER_CLOSING_COLOR.raw}
      />

      <Divider small />
      <div className={st.Divider} />
      <Divider small />

      <CheckboxCustomFilter
        control={control}
        isMulti
        label={t('events:sleeve')}
        name="sleeve_lengths"
        options={EVENT_ENUMS.UPPER_BODY.SLEEVE.raw}
      />
    </CustomFilterPopover>
  );
};
